'use client';

import React from 'react';

import { Section, Container } from '@layout';
import { Filters, Heading } from '@ui';
import MarkupSnippet, { markupCopyLabels } from '../markup-snippet/MarkupSnippet';

interface FilterDemoProps {
  sectionID?: string;
  classes?: string;
  containerId?: string;
  containerClasses?: string;
  isSpanish?: boolean;
}

const FiltersDemo: React.FC<FilterDemoProps> = ({
  isSpanish = false,
  sectionID = 'filters',
  classes = '',
  containerId,
  containerClasses,
}) => {
  const t = (en: string, es: string) => (isSpanish ? es : en);

  return (
    <Section sectionID={sectionID} className={classes}>
      <Container containerId={containerId} containerClasses={containerClasses}>
        <Heading as='h3'>{t('Filters', 'Filtros')}</Heading>
        <p className='sub'>
          {t(
            'Toggle chips with counts, “Clear all,” and live results.',
            'Alterna chips con conteo, “Borrar todo” y resultados en vivo.'
          )}
        </p>

        <Filters />
        <MarkupSnippet
          {...markupCopyLabels(isSpanish)}
          code={`<div class="card filters-card">
  <div class="row filters-chips">
    <button class="chip-toggle is-on" type="button">Open <span class="count">12</span></button>
    <button class="chip-toggle" type="button">Closed</button>
    <button class="btn btn-ghost btn-sm" type="button">Clear all</button>
  </div>
</div>`}
        />
      </Container>
    </Section>
  );
};

export default FiltersDemo;
